var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunSetting03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun-setting-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.1001 34.8542C12.1168 35.7708 14.6835 35.7708 16.7001 34.8542C18.7168 33.9375 21.2835 33.9375 23.3001 34.8542C25.3168 35.7708 27.8835 35.7708 29.9001 34.8542M20 5V8.33333M6.66671 21.6667H3.33337M10.5236 12.1902L8.16654 9.83317M29.476 12.1902L31.833 9.83317M36.6667 21.6667H33.3334M11.6667 21.6667C11.6667 17.0643 15.3977 13.3333 20 13.3333C24.6024 13.3333 28.3334 17.0643 28.3334 21.6667M3.5002 29.0208C5.51687 28.1042 8.08354 28.1042 10.1002 29.0208C12.1169 29.9375 14.6835 29.9375 16.7002 29.0208C18.7169 28.1042 21.2835 28.1042 23.3002 29.0208C25.3169 29.9375 27.8835 29.9375 29.9002 29.0208C31.9169 28.1042 34.4835 28.1042 36.5002 29.0208",
    stroke: "#D7600A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunSetting03);
export default __webpack_public_path__ + "static/media/sun-setting-03.4131f25aa99988c18d3f83077b12dcf3.svg";
export { ForwardRef as ReactComponent };